import { TGpsrRegulationsItem } from 'redux/reducers/gpsr/types';
import { EIconButtons } from 'services/constants/iconsTypes';
import { ETableStructureAlign, ETableStructureType } from 'services/constants/tableStructureTypes';

export const gpsrRegulationsTableStructure = [
	{
		name: 'ID',
		selector: 'id' as keyof TGpsrRegulationsItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Regulation Name',
		selector: 'name' as keyof TGpsrRegulationsItem,
		show: true,
		sortable: true,
		filterable: false,
		searchable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Actions',
		selector: 'File Report' as keyof TGpsrRegulationsItem,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: 'Delete', icon: EIconButtons.DELETE }],
		colSpan: 1,
	},
];
